import type { MutationTree, ActionTree, Plugin } from 'vuex';
import type { RootState } from '~/types/store';
import { toCamelTransformator } from '~/components/utils/core/object';

const watchUser: Plugin<RootState> = store => {
  store.watch(
    state => state.auth?.loggedIn,
    isLoggedIn => {
      // if (isLoggedIn) store.dispatch('ui/showNextOnboardingTooltip');
    },
  );
};

export const plugins = [watchUser];

export const state = (): Partial<RootState> => ({
  promo: 'OPEN',
  abTest: '',
  shouldSyncAmplitudeUserProperties: false,
  settings: {
    specialUsers: [],
  },
});

export const mutations: MutationTree<RootState> = {
  setPromo(state, newPromo) {
    state.promo = newPromo;
  },
  setAbTest(state, newAbTest) {
    state.abTest = newAbTest;
  },
  enableShouldSetAmplitudeUserProperties(state) {
    state.shouldSyncAmplitudeUserProperties = true;
  },
  updateState(state, newState) {
    Object.assign(state, newState);
  },
};

export const actions: ActionTree<RootState, RootState> = {
  async nuxtServerInit({ dispatch }, { req, $auth }) {
    if (req.url !== '/ping' && $auth.loggedIn) {
      await dispatch('fetchAppSettings');
    }
  },
  resetState({ commit }) {
    ['portfolio', 'chat'].forEach(module => {
      commit(`${module}/resetState`, null, { root: true });
    });
  },
  async signOut({ dispatch }) {
    await this.$auth.logout();
    dispatch('resetState');
  },
  async fetchAppSettings({ commit }) {
    const { settings } = await this.$api.$get(`/api/settings.json`, {
      // @ts-ignore
      transformResponse: [...this.$api.defaults.transformResponse, toCamelTransformator],
    });

    commit('updateState', { settings });
  },
};
